import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsoleLoggerService {

  constructor() { }

  disableLogsInProd() {
    if (environment.loggerDisable) {
      console.log = function (): void { };
    }
  }

}